import { AppState } from '../../slices/appSlice';
import { Bid, BidComponentProps, levels } from '../../app/types';
import { Sets } from '../card-component/sets';
import { useTranslation } from 'react-i18next';
import React, { FunctionComponent, useRef, useState } from 'react';

import './shark-bid-component.scss';
import { convertCalltoStrain } from '../../app-interfaces/game-engine-helper';
import { getLevelStrainFromCall } from '../../utils/mixed';
import { isMobile } from 'react-device-detect';
import { outputActions } from '../../slices/outputSlice';
import { useAppDispatch } from '../../app/hooks';
import { useGesture } from '@use-gesture/react';

export type BiddingBoxProps = {
    bid: BidComponentProps['bid'];
    selectedCardSet: AppState['sharkLayout']['selectedCardSet'];
    indexDealerIndex?: number;
    activeHover?: boolean;
    makeCall?: (bid: Bid) => () => void;
    alert?: string;
};

export const SharkBidComponent: FunctionComponent<BiddingBoxProps> = (props) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { output_setBidExplanation, output_bidExplanationCancel, output_myBidExplanationRequest } = outputActions;
    //const [preventCall, setPreventCall] = useState(false);


    const { bid, selectedCardSet, indexDealerIndex, activeHover, makeCall } = props;

    const isStake = ['rdbl', 'xdbl', 'pass', 'auctionAlert'].indexOf(bid.call) !== -1;
    const strain = convertCalltoStrain(bid.call);
    const { level } = getLevelStrainFromCall(bid.call);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const mobileTest = false;
    const hoverDelay = 500;
    const gesture = useGesture(
        {
            onHover: (state) => {
                const { hovering } = state;
                // Clear any existing timeout
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
                if (hovering) {
                    // Set a delayed effect when hovering starts
                    timeoutRef.current = setTimeout(() => {
                        requestBidExplanation(state, 'onHover');
                    }, hoverDelay);
                } else {
                    cancelBidExplanation();
                 }
            },
            onClick: (state) => {
                cancelBidExplanation();
                 props.makeCall?.(props.bid)();
            },
            onDragStart: (state) => {
                if (isMobile || mobileTest) {
                    requestBidExplanation(state, 'onDragStart');
                }
            },
            onDrag: (state) => {
                // we cancel requestMyBidExplanation and prevent action as soon as we start to drag
                const dist = 10;
                if ((isMobile && state.distance[0] > dist) || state.distance[1] > dist) {
                    cancelBidExplanation();
                }
            },
        },
        {
            hover: {
                // Optional: configure hover options
                mouseOnly: true, // Only respond to mouse events, not touch
            },
        },
    );

    const requestBidExplanation = (state: any, origin: string) => {
        if (indexDealerIndex === undefined) {
            dispatch(output_myBidExplanationRequest(bid));
        } else {
            dispatch(output_setBidExplanation(indexDealerIndex));
        }
    };

    const cancelBidExplanation = () => {
      //  dispatch(output_bidExplanationCancel(true));
    };

    return (
        <section
            className={`SharkBidComponent ${strain} ${levels[level]} ${bid.call} ${bid.alertMessage ? 'withAlert' : ''}`}
            {...(activeHover && gesture([]))}
        >
            {isStake ? <div>{t(`stake.${bid.call}`)}</div> : Sets[selectedCardSet].biddings}
            {props.alert}
            {/*{strain ? (*/}
            {/*    ['double', 'redouble', 'pass', 'auctionAlert', 'auctionStop'].indexOf(strain) !== -1 ? (*/}
            {/*        <div>{t(`strain.${strain}`)}</div>*/}
            {/*    ) : (*/}
            {/*        Sets[selectedCardSet].biddings*/}
            {/*    )*/}
            {/*) : (*/}
            {/*    <div />*/}
            {/*)}*/}
        </section>
    );
};
